import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'worm-choose-identification-type',
  templateUrl: './choose-identification-type.component.html',
  styleUrls: ['./choose-identification-type.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseIdentificationTypeComponent {
  @Input() set identificationTypes(identificationTypes: string) {
    this.internalTypes = JSON.parse(identificationTypes);
    if (this.internalTypes.length === 1) {
      this.selectedType = this.internalTypes[0];
    }
  }

  @Input() get value(): string {
    return this.selectedType;
  }

  @Input() get validate(): Function {
    return () => !!this.selectedType;
  }

  selectedType: string;

  internalTypes = ['OFFLINE', 'LIVEID', 'VIDEOID'];

  buttonId(identificationType: string): string {
    return `start-${identificationType.toLowerCase()}-btn`;
  }

  onSelectIdentificationType(selected: string): void {
    this.selectedType = selected;
  }

  isNotSelected(type: string): boolean {
    return this.selectedType && this.selectedType !== type;
  }
}
